export default {
      id: "stat-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "img/icons.adde2a28.svg#stat",
      toString: function () {
        return this.url;
      }
    }